export default __webpack_public_path__ + "3c69c4009ae84136ab1711f8c5a34172.png";